<app-menu/>

<div class="column shrink mobile-version">
  <a routerLink="/account" class="alert">Продовжити покупки</a>
</div>

<div class="page-container">
  <div class="orders_history">
    <div class="row">
      <div class="column shrink">
        <h2 class="desktop-version">Замовлення для повернення</h2>
      </div>
    </div>
    <div class="row mobile-version">
      <div class="column shrink">
        <h2>Замовлення</h2>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div class="search-string">
          <input
            type="text"
            class="input-search"
            [(ngModel)]="search"
            placeholder="Пошук по: артикул, номер замовлення, адрес доставки"
            (input)="searchData()"
          >
          <label *ngIf="search === ''" class="search-icon"></label>
          <button type="button" *ngIf="search !== ''" class="cross-clears" (click)="crossClears()"></button>

          <div class="column shrink mobile-version">
            <button type="submit" *ngIf="search === ''">Знайти</button>
            <button type="button" *ngIf="search !== ''" (click)="crossClears()">Видалити</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="orders">
      <div class="column">
        <table class="data">
          <thead>
          <tr>
            <th class="date-style">Дата</th>
            <th>Замовлення</th>
            <th>Коментар</th>
            <th>Тип доставки</th>
            <th class="desktop-version">Статус замовлення</th>
            <th class="desktop-version">№ декларації</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders" [class.assistant-highlight]="highlight.has(order.id)">
              <td>
                {{ order.date }}
              </td>
              <td class="order" (click)="showOrder(order)">
                <a>Замовлення №{{ order.id }}</a>
                <small *ngIf="order.summa > 0" class="abovezero desktop-version">
                  Сума:{{ (order.summa).toFixed(2) }} грн.
                </small>
                <small class="abovezero-nalojki" *ngIf="order.summa_nalojki">
                  Сума наложкі: {{ order.summa_nalojki }} грн.
                </small>
              </td>
              <td>
                {{ order.comment }}
              </td>
              <td>
                {{ order.courier }}
                <small *ngIf="order.datedelivery" class="abovezero-type">
                  Доставка: {{ order.datedelivery }}
                </small>
              </td>
              <td class="desktop-version">
                <a class="status">
                  <span *ngIf="order.all_returned else declaracia">Повернення</span>
                </a>
                <ng-template class="status" #declaracia>
                  <a (click)="showTrackStatus(order)">
                    <span *ngIf="order.status_id == 4 || order.declaraciya else statusNew"
                          class="status">Відвантажено</span>
                  </a>
                </ng-template>
                <ng-template class="status beige" #statusNew>
                  <a (click)="showTrackStatus(order)">
                    <span *ngIf="order.status_id == 1" class="status beige">Новий</span>
                  </a>
                </ng-template>
                <ng-template class="status red" #statusReady>
                  <span *ngIf="order.status_id == 5" class="status red">Зібраний та запакований</span>
                </ng-template>
              </td>
              <td class="desktop-version">
                {{ order.declaraciya }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="footer-goods mobile-version">
    <footer>
      <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
    </footer>
  </div>
</div>

<app-modal-select-goods-return
  [dels]="dels"
  [currencies]="currencies"
  [returnStatuses]="returnStatuses"
  [allow_to_return_goods_from_zakupolog]="allow_to_return_goods_from_zakupolog"
>
</app-modal-select-goods-return>

<div class="modalka-show-track-status" [class.track-status-modal-show]="isTrackStatusModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div *ngIf="trackStatusOrder && trackStatusOrder.status_id === 1" class="place-for-track-status-data">В процесі</div>
  <ng-container *ngIf="trackStatusOrderProductsWars">
    <div class="place-for-track-status">Переміщення</div>
    <div class="place-for-track-status" *ngFor="let op of trackStatusOrderProductsWars">
      З {{ op.to_w }} на {{ op.from_w }}
    </div>
    <ng-container *ngIf="trackStatusTransfer">
      <table class="track-status-table">
        <thead>
        <tr>
          <th>Дата прибуття</th>
          <th>Зі складу</th>
          <th>На склад</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let transfer of trackStatusTransfer">
          <td>{{ transfer.arrived_datetime | date: 'dd.MM.Y HH:mm:ss' }}</td>
          <td>{{ transfer.from_w }}</td>
          <td>{{ transfer.to_w }}</td>
          <td>{{ transfer.arrived ? 'Доставлено' : 'В дорозі' }}</td>
        </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
  <div class='track-status-center' *ngIf="trackStatusOrder && trackStatusOrder.trakstatus">
    {{ trackStatusOrder.trakstatus }}
  </div>
  <div class='track-status-center'
       *ngIf="trackStatusOrder && trackStatusOrder.datedelivery && trackStatusContactsDrivers">
    {{ trackStatusContactsDrivers.contacts }}
  </div>
</div>

<app-modal-partners-not-return-orders-message (agreeEvent)="agree()"/>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
